export default {
  apiKey: 'AIzaSyDcLSY2mlstralIMEIn1y31gfY8sg0OxYQ'
}
